module.exports = __webpack_public_path__ + "img/cheliang.a03d28c1.png";